import script from "./PaymentItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentItem.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentItem.vue?vue&type=style&index=0&id=7eaa596a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eaa596a"]])

export default __exports__